import { Component, OnInit, ViewChild } from '@angular/core'
import { BeneficiarySoaDetail } from '../models/view-soa-model'
import { SearchInsertModel } from '../models/search-soa-model'
import { ValidatedSelectOptionModel } from '../../validations/validated-dropdown.component'
import { ExcelService } from '../excel.service'
import { ViewSOAGateWay } from '../gateways/view-soa-gateways'
import { CurrentUser } from '../../common/models/current-user'
import { UserAccessGateway } from '../../common/gateways/user-access-gateway'
import { ExportSOAModel } from '../models/export-soa-model'
import { jqxGridComponent } from 'jqwidgets-ng/jqxgrid'
import { JqxGridVirtualPaging } from '../../../app/common/utilclasses/jqxgrid-virtualpaging'
import { Router } from '@angular/router'
import * as moment from 'moment'
import * as _ from 'lodash'
import { PortalGlobals } from '../../portalglobals'

@Component({
    selector: 'viewsoa',
    templateUrl: 'view-soa.component.html',
    styleUrls: ['view-soa.component.scss']
})
export class ViewElectronicSOAComponent implements OnInit {
    @ViewChild('gridReference', { static: true }) myGrid: jqxGridComponent
    beneficiarySOAViewModel: BeneficiarySoaDetail[]
    viewSOAModel: BeneficiarySoaDetail
    searchInsertModel: SearchInsertModel
    beneficiaryStatus: ValidatedSelectOptionModel[]
    exportSOA: ExportSOAModel[]
    //  SearchInsertModel: any = { BeneficiaryName: '', BeneficaryEmail: '', AgentId: '', Status: ''}

    showAgentID: boolean

    order: string = 'RecCreateTS'
    reverse: boolean = true
    p: number = 1
    key: string = 'RecCreateTS'

    totalRec: number
    public currentUser: CurrentUser = {} as CurrentUser
    downloadError: string
    serviceResponse: string
    IsrecordFound: boolean
    curUserProfileName: string
    public loading: boolean = false
    skipCall: boolean
    chunkSize: number = 10000
    jqxGridVirtualPaging: JqxGridVirtualPaging
    totalCount: number
    showSOAButton: boolean = true
    jqx: any
    data: any = []
    source: any = {
        localdata: this.data,
        datatype: 'array',
        datafields: [
            { name: 'BeneficiaryName', type: 'string' },
            { name: 'BeneficiaryEmail', type: 'string' },
            { name: 'AgentUserProfileName', type: 'string' },
            { name: 'FormStatus', type: 'string' },
            { name: 'RecCreateTS', type: 'date' },
            { name: 'PlanYear', type: 'number' },
            { name: 'BeneficiaryPdf', type: 'string' }
        ]
    }

    dataAdapter: any = new jqx.dataAdapter(this.source)

    columns: any[] = [
        { text: 'Beneficiary Name', columntype: 'textbox', datafield: 'BeneficiaryName', width: 150, editable: false },
        { text: 'Beneficiary Email', columntype: 'textbox', datafield: 'BeneficiaryEmail', width: 300, editable: false },
        { text: 'Agent ID', columntype: 'textbox', datafield: 'AgentUserProfileName', width: 150, editable: false },
        { text: 'Status', columntype: 'textbox', datafield: 'FormStatus', width: 150, editable: false },
        { text: 'Date Created', datafield: 'RecCreateTS', columntype: 'textbox', width: 175, editable: false, cellsformat: 'MM/dd/yyyy h:mm tt' },
        { text: 'Plan Year', columntype: 'textbox', datafield: 'PlanYear', width: 100, editable: false },
        {
            text: '',
            datafield: 'BeneficiaryPdf',
            cellsalign: 'center',
            width: 150,
            editable: false,
            sortable: false,
            filterable: false,
            menu: false,
            cellsRenderer: function (row, columnfield, value, id, columnData, rowData) {
                if (rowData.FormStatus === 'Signed') {
                    return '<a class="link-button link download-pdf">Download</a>'
                } else {
                    return ''
                }
            }
        }
    ]

    constructor(
        private excelService: ExcelService,
        private viewSOAGateWay: ViewSOAGateWay,
        private _networkUserAccessGateway: UserAccessGateway,
        private router: Router,
        public _global: PortalGlobals
    ) {
        ;(this.excelService = excelService), (this.jqxGridVirtualPaging = new JqxGridVirtualPaging())
    }
    ngOnInit() {
        this.BindSOAData()
    }

    BindSOAData() {
        this.searchInsertModel = {} as SearchInsertModel
        this.viewSOAModel = {} as BeneficiarySoaDetail
        // getting user object from session
        this.loading = true
        this.skipCall = true
        this._networkUserAccessGateway.getCurrentUser().subscribe(
            (user) => {
                if (user != null) {
                    this.currentUser = user
                    this.populateSOAHistory()
                } else {
                    // already exists in session
                    this.viewSOAModel.OrgID = this.currentUser.orgId
                    this.viewSOAModel.UserProfileID = this.currentUser.userProfileId
                    this.viewSOAModel.PageNumber = 1
                    this.viewSOAModel.PageSize = 20
                    // for search
                    this.searchInsertModel.OrgID = this.currentUser.orgId
                    this.searchInsertModel.UserProfileID = this.currentUser.userProfileId
                    this.searchInsertModel.PageNumber = 1
                    this.searchInsertModel.PageSize = 20

                    if (
                        this.currentUser.isOrganizationalAdmin ||
                        this.currentUser.isOrganizationalManager ||
                        this.currentUser.UserProfileStatusCode === 'Inactive'
                    )
                        this.showSOAButton = false

                    this.showHideAgentID()

                    this.viewSOAGateWay.loadBSOAData(this.viewSOAModel).subscribe(
                        (model: BeneficiarySoaDetail[]) => {
                            model.map((row) => {
                                row.RecCreateTS = moment(row.RecCreateTS).subtract(7, 'h').format('MM/DD/YYYY hh:mm A')
                            })
                            this.beneficiarySOAViewModel = model
                            this.source.localdata = this.beneficiarySOAViewModel
                            this.totalCount = this.source.totalrecords = this.beneficiarySOAViewModel[0].TotalRecords

                            this.dataAdapter.dataBind()
                            this.myGrid.updatebounddata()
                            this.loading = false
                            this.skipCall = false
                        },
                        (err) => {
                            this.loading = false
                        }
                    )
                }
            },
            (err) => {
                this.loading = false
            }
        )
        // this.loading = false
        this.SetBeneficiaryStatus()
        //this.totalRec = this.beneficiarySOAViewModel.length
    }

    populateSOAHistory() {
        if (
            this.currentUser.isOrganizationalAdmin ||
            this.currentUser.isOrganizationalManager ||
            this.currentUser.UserProfileStatusCode === 'Inactive'
        )
            this.showSOAButton = false

        this.viewSOAModel.OrgID = this.currentUser.orgId
        this.viewSOAModel.UserProfileID = this.currentUser.userProfileId
        this.viewSOAModel.PageNumber = 1
        this.viewSOAModel.PageSize = 20
        // for search
        this.curUserProfileName = this.currentUser.userProfileName
        this.searchInsertModel.OrgID = this.currentUser.orgId
        this.searchInsertModel.UserProfileID = this.currentUser.userProfileId
        this.searchInsertModel.PageNumber = 1
        this.searchInsertModel.PageSize = 20

        this.showHideAgentID()
        this.loadSOAHistoryData()
    }

    loadSOAHistoryData() {
        if (this.currentUser.AetnaInd === true) {
            this.viewSOAGateWay.loadPWBSOAData(this.viewSOAModel).subscribe(
                (model: BeneficiarySoaDetail[]) => {
                    this.processSOAHistoryData(model)
                },
                (err) => {
                    this.loading = false
                }
            )
        } else {
            this.viewSOAGateWay.loadBSOAData(this.viewSOAModel).subscribe(
                (model: BeneficiarySoaDetail[]) => {
                    this.processSOAHistoryData(model)
                },
                (err) => {
                    this.loading = false
                }
            )
        }
    }

    processSOAHistoryData(model: BeneficiarySoaDetail[]) {
        if (model.length === 0) {
            this.IsrecordFound = true
            this.loading = false
            this.serviceResponse = 'No Record Found'
        } else {
            model.map((row) => {
                row.RecCreateTS = moment(row.RecCreateTS).subtract(7, 'h').format('MM/DD/YYYY hh:mm A')
            })
            this.beneficiarySOAViewModel = model
            this.IsrecordFound = false
            this.totalCount = this.source.totalrecords = this.beneficiarySOAViewModel[0].TotalRecords
            this.source.localdata = this.beneficiarySOAViewModel

            this.dataAdapter.dataBind()
            this.myGrid.updatebounddata()
            this.loading = false
            this.skipCall = false
        }
    }

    showHideAgentID() {
        if (
            this._global.currentUser.IsGuruAdmin ||
            this._global.currentUser.IsSuperAdminAdmin ||
            this._global.currentUser.IsSuperAdminSMA ||
            this._global.currentUser.IsSuperAdminSMM ||
            this._global.currentUser.isOrganizationalManager ||
            this._global.currentUser.isOrganizationalAdmin ||
            this._global.currentUser.IsAdminOrAgent
        ) {
            this.showAgentID = true
        } else {
            this.showAgentID = false
        }
    }

    SetBeneficiaryStatus() {
        this.beneficiaryStatus = [
            {
                text: '0',
                value: 'All'
            },
            {
                text: '1',
                value: 'Signed'
            },
            {
                text: '2',
                value: 'Expired'
            },
            {
                text: '3',
                value: 'Viewed'
            },
            {
                text: '4',
                value: 'In Progress'
            }
        ]
    }

    setOrder(value: string) {
        this.key = value
        this.reverse = !this.reverse
    }

    // calls when exportToExcel is clicked
    exportToExcel() {
        //reset agentuserprofilename. assign UserProfileName only when AgentID is entered on screen
        this.searchInsertModel.AgentUserProfileName = ''
        if (this.searchInsertModel.AgentId !== undefined && this.searchInsertModel.AgentId !== null && this.searchInsertModel.AgentId !== '') {
            this.searchInsertModel.AgentUserProfileName = this.searchInsertModel.AgentId
        }

        // if (this.totalCount < this.chunkSize) {
        this.searchInsertModel.PageNumber = 1
        this.searchInsertModel.PageSize = this.totalCount
        if (this.currentUser.AetnaInd === true) {
            this.viewSOAGateWay.getPWSOADataForExport(this.searchInsertModel).subscribe(
                (model: ExportSOAModel[]) => {
                    this.processSOADataForExport(model)
                },
                (err) => {
                    this.loading = false
                }
            )
        } else {
            this.viewSOAGateWay.getSOADataForExport(this.searchInsertModel).subscribe(
                (model: ExportSOAModel[]) => {
                    this.processSOADataForExport(model)
                },
                (err) => {
                    this.loading = false
                }
            )
        }
    }

    processSOADataForExport(model: ExportSOAModel[]) {
        let summary: ExportSOAModel[] = [] as ExportSOAModel[]
        summary = model
        let array = _.clone(summary)

        let strArray = JSON.stringify(array)
        strArray = strArray.replace(/BeneficiaryName/g, 'Beneficiary Name')
        strArray = strArray.replace(/BeneficiaryEmail/g, 'Beneficiary Email')
        strArray = strArray.replace(/AgentID/g, 'Agent ID')
        strArray = strArray.replace(/Status/g, 'Status')
        strArray = strArray.replace(/DateCreated/g, 'Date Created')
        strArray = strArray.replace(/PlanYear/g, 'Plan Year')
        strArray = strArray.replace(/ConfirmationNumber/g, '')
        this.exportSOA = JSON.parse(strArray)

        if (this.exportSOA.length === 0) {
            this.IsrecordFound = true
            this.serviceResponse = 'No Record Found'
        } else {
            this.excelService.exportAsExcelFile(this.exportSOA, 'BeneficiaryReport')
            this.IsrecordFound = false
        }
    }

    CellclickOnEdit(event: any): void {
        if (event.args.column.text === '') {
            let pdf = event.args.row.bounddata.BeneficiaryPdf
            if (pdf.length > 0) {
                let downloadDetail = {} as BeneficiarySoaDetail
                downloadDetail.BeneficiaryPdf = pdf
                this.downloadPDF(downloadDetail)
            }
        }
    }

    // downloads PDF
    downloadPDF(beneficiarysoadetail: BeneficiarySoaDetail) {
        this.loading = true
        this.viewSOAGateWay.streamPDF(beneficiarysoadetail).subscribe(
            (res) => {
                this.loading = false
                if (window.navigator && (window.navigator as any).msSaveOrOpenBlob) {
                    ;(window.navigator as any).msSaveOrOpenBlob(new Blob([res], { type: 'application/pdf' }), beneficiarysoadetail.BeneficiaryPdf)
                }
                var url = window.URL.createObjectURL(res)
                var a = document.createElement('a')
                document.body.appendChild(a)
                a.setAttribute('style', 'display: none')
                a.href = url
                a.download = beneficiarysoadetail.BeneficiaryPdf
                a.click()
                window.URL.revokeObjectURL(url)
                a.remove()
            },
            (error) => {
                this.loading = false
                console.log('download error:', JSON.stringify(error))
            },
            () => {
                this.loading = false
                console.log('Completed file download.')
            }
        )
    }

    //send a new SOA
    sendNewSOA() {
        const insCo = this.currentUser.insuranceCompanyShortName.toLowerCase()
        this.router.navigate(['/' + insCo + '/electronic-soa/submitsoa'])
    }

    // calls when user clicks on search
    searchBSOAData(searchModel: SearchInsertModel) {
        if (searchModel.BeneficiaryName === '') {
            searchModel.BeneficiaryName = ''
        }

        if (searchModel.BeneficiaryEmail === '') {
            searchModel.BeneficiaryEmail = ''
        }

        if (searchModel.AgentId === '') {
            searchModel.AgentId = ''
        }

        this.loading = true
        this.IsrecordFound = false
        //reset agentuserprofilename. assign UserProfileName only when AgentID is entered on screen
        this.searchInsertModel.AgentUserProfileName = ''
        if (this.searchInsertModel.AgentId !== undefined && this.searchInsertModel.AgentId !== null && this.searchInsertModel.AgentId !== '') {
            this.searchInsertModel.AgentUserProfileName = this.searchInsertModel.AgentId
        }
        this.searchInsertModel.PageNumber = 1
        if (this.searchInsertModel.PageSize === null) {
            this.searchInsertModel.PageSize = 20
        }
        this.searchInsertModel.FilterCriteria = ''
        this.searchInsertModel.SortFields = ''
        if (this.myGrid !== null && this.myGrid !== undefined) {
            //Workaround to stop triggering of OnFilter and OnSort event, when filters and sort are cleared
            this.skipCall = true
            this.myGrid.clearfilters()
            this.myGrid.removesort()
        }

        if (this.currentUser.AetnaInd === true) {
            this.viewSOAGateWay.searchPWBSOAData(searchModel).subscribe(
                (model: BeneficiarySoaDetail[]) => {
                    this.processSOASearchResults(model)
                },
                (err) => {
                    this.loading = false
                }
            )
        } else {
            this.viewSOAGateWay.searchBSOAData(searchModel).subscribe(
                (model: BeneficiarySoaDetail[]) => {
                    this.processSOASearchResults(model)
                },
                (err) => {
                    this.loading = false
                }
            )
        }
    }

    processSOASearchResults(model: BeneficiarySoaDetail[]) {
        this.beneficiarySOAViewModel = model
        if (model.length === 0) {
            this.source.localdata = ''
            this.dataAdapter.dataBind()
            this.myGrid.updatebounddata()
            this.IsrecordFound = true
            this.serviceResponse = 'No Record Found'
            this.loading = false
            this.skipCall = false
        } else {
            this.IsrecordFound = false
            model.map((row) => {
                row.RecCreateTS = moment(row.RecCreateTS).subtract(7, 'h').format('MM/DD/YYYY hh:mm A')
            })
            this.source.localdata = this.beneficiarySOAViewModel
            this.source.totalrecords = this.beneficiarySOAViewModel[0].TotalRecords

            this.dataAdapter.dataBind()
            this.myGrid.updatebounddata()
            this.loading = false
            this.skipCall = false
        }
    }

    rendergridrows = (params: any): any[] | undefined => {
        if (!isNaN(params.startindex)) {
            this.searchInsertModel.PageNumber = Math.floor(params.startindex / this.searchInsertModel.PageSize) + 1
            if (!this.skipCall) {
                this.beneficiarySOAViewModel = this.viewSOAGateWay.loadBSOADataSync(this.searchInsertModel)
                this.beneficiarySOAViewModel.map((row) => {
                    row.RecCreateTS = moment(row.RecCreateTS).subtract(7, 'h').format('MM/DD/YYYY hh:mm A')
                })
            }
            return this.beneficiarySOAViewModel
        }
    }

    ready = (): void => {
        this.myGrid.localizestrings(this.jqxGridVirtualPaging.ready())
    }

    onFilter(event: any): void {
        if (!this.skipCall) {
            this.skipCall = true
            let filterinfo = this.myGrid.getfilterinformation()

            this.searchInsertModel.FilterCriteria = this.jqxGridVirtualPaging.onFilter(event, filterinfo)
            let summary = this.viewSOAGateWay.loadBSOADataSync(this.searchInsertModel)
            if (summary !== null || summary !== undefined) {
                summary.map((row) => {
                    row.RecCreateTS = moment(row.RecCreateTS).subtract(7, 'h').format('MM/DD/YYYY hh:mm A')
                })
                this.beneficiarySOAViewModel = summary
                this.source.localdate = summary
                this.source.totalrecords = summary[0].TotalRecords

                this.dataAdapter.dataBind()
                this.myGrid.updatebounddata()
            }
            this.skipCall = false
        }
    }

    onSort(event: any): void {
        if (!this.skipCall) {
            this.skipCall = true
            this.searchInsertModel.SortFields = this.jqxGridVirtualPaging.onSort(event)
            let summary = this.viewSOAGateWay.loadBSOADataSync(this.searchInsertModel)
            if (summary !== null || summary !== undefined) {
                summary.map((row) => {
                    row.RecCreateTS = moment(row.RecCreateTS).subtract(7, 'h').format('MM/DD/YYYY hh:mm A')
                })
                this.beneficiarySOAViewModel = summary
                this.source.localdate = summary
                this.source.totalrecords = summary[0].TotalRecords
                this.dataAdapter.dataBind()
                this.myGrid.updatebounddata()
            }
            this.skipCall = false
        }
    }

    onPageSizeChanged(event: any): void {
        if (!this.skipCall) {
            this.skipCall = true
            let args = event.args
            this.source.pagesize = this.searchInsertModel.PageSize = args.pagesize
            let summary = this.viewSOAGateWay.loadBSOADataSync(this.searchInsertModel)
            if (summary !== null || summary !== undefined) {
                summary.map((row) => {
                    row.RecCreateTS = moment(row.RecCreateTS).subtract(7, 'h').format('MM/DD/YYYY hh:mm A')
                })
                this.beneficiarySOAViewModel = summary
                this.source.localdate = summary
                this.dataAdapter.dataBind()
                this.myGrid.updatebounddata()
            }
            this.skipCall = false
        }
    }

    updatefilterconditions = (type: string, defaultconditions: any): string[] | undefined => {
        return this.jqxGridVirtualPaging.updatefilterconditions(type)
    }

    onKeyDown(event) {
        const ENTER_KEY = 13
        if (event.keyCode === ENTER_KEY) {
            this.searchBSOAData(this.searchInsertModel)
        }
    }
}
